import { render, staticRenderFns } from "./FormPhieuTuVan.vue?vue&type=template&id=4fbac76d&scoped=true"
import script from "./FormPhieuTuVan.vue?vue&type=script&lang=js"
export * from "./FormPhieuTuVan.vue?vue&type=script&lang=js"
import style0 from "./FormPhieuTuVan.vue?vue&type=style&index=0&id=4fbac76d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbac76d",
  null
  
)

export default component.exports